export const userAccount = state => state.userAccount;
export const creditCards = state => state.billingData;
export const statusFetch = state => state.cards.status;
export const fwdAddrList = state => state.fwdAddrList;
export const smsService = state => state.smsService;
export const userStats = state => state.userStats;
export const jointAccounts = state => state.jointAccounts;
export const notarizeList = state => state.notarizeList;
export const phoneList = state => state.phoneList;
export const userPlan = state => state.userPlan;
export const form1583Signed = state => state.form1583Signed;
